// eslint-dis
const FormatError = (error) => {
  if (!error) return error;
  // Process error if it contains an error object, generated by the optimization server
  if (!error.response || !error.response.data || !error.response.data.error) {
    if (!error.response || !error.response.status || (error.response.status === -1)) {
      return 'Server down or unreachable';
    }
    if (error.response.status >= 500) {
      return `Internal server error ${error.response.status}`;
    }
    if (error.response.status >= 400) {
      return `Invalid data ${error.response.status}`;
    }
    return `Server error ${error.response.status}`;
  }
  const serverError = error.response.data.error;
  return serverError.code ? `[${serverError.code}] ${serverError.message}` : serverError.message;
};

export { FormatError }; // eslint-disable-line import/prefer-default-export
